export enum VideoType {

	Trailer = 'trailer',
	Video = 'video'
}